import { createTheme, ThemeOptions } from '@mui/material/styles';

const common: ThemeOptions = {
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        h1: { fontWeight: 800, letterSpacing: '-0.02em' },
        h2: { fontWeight: 700, letterSpacing: '-0.01em' },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        body1: { lineHeight: 1.7 },
        body2: { lineHeight: 1.6 },
    },
    shape: { borderRadius: 16 },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 12,
                    padding: '10px 24px',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { borderRadius: 8, fontWeight: 500 },
            },
        },
    },
};

export const lightTheme = createTheme({
    ...common,
    palette: {
        mode: 'light',
        primary: { main: '#2563EB', light: '#60A5FA', dark: '#1D4ED8' },
        secondary: { main: '#7C3AED', light: '#A78BFA', dark: '#5B21B6' },
        background: { default: '#F8FAFC', paper: '#FFFFFF' },
        text: { primary: '#0F172A', secondary: '#475569' },
        divider: '#E2E8F0',
    },
    components: {
        ...common.components,
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
                    border: '1px solid #F1F5F9',
                    transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                    '&:hover': { boxShadow: '0 10px 40px rgba(0,0,0,0.08)' },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(248,250,252,0.8)',
                    backdropFilter: 'blur(20px)',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    borderBottom: '1px solid #E2E8F0',
                },
            },
        },
    },
});

export const darkTheme = createTheme({
    ...common,
    palette: {
        mode: 'dark',
        primary: { main: '#60A5FA', light: '#93C5FD', dark: '#2563EB' },
        secondary: { main: '#A78BFA', light: '#C4B5FD', dark: '#7C3AED' },
        background: { default: '#0B1120', paper: '#131C31' },
        text: { primary: '#F1F5F9', secondary: '#94A3B8' },
        divider: '#1E293B',
    },
    components: {
        ...common.components,
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                    border: '1px solid #1E293B',
                    transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
                    '&:hover': {
                        boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                        borderColor: '#334155',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(11,17,32,0.8)',
                    backdropFilter: 'blur(20px)',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                    borderBottom: '1px solid #1E293B',
                },
            },
        },
    },
});
